import {Pet} from '../shared/pets/pet';
import {PhoneNumber} from '../customer/PhoneNumber';

export class HIUser {
  sid: number;
  firstName: string;
  surname: string;
  email: string;
  title: string;
  streetAddress: string;
  town: string;
  postCode: string;
  password: string;
  pets: Pet[];
  telephoneNumbers: PhoneNumber[];
}
